const urlsafeEncode = (input) => {
  return Buffer
    .from(input)
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')
}

const urlsafeDecode = (input) => {
  return Buffer
    .from(
      input
        .replace(/-/g, '+')
        .replace(/_/g, '/'),
      'base64'
    )
    .toString()
}

export {
  urlsafeEncode,
  urlsafeDecode
}
